import { useTranslation } from 'react-i18next'
import { useModalOpened, useModalToggle } from '~/state/application/hooks'
import { ApplicationModal } from '~/state/application/reducer'
import Modal from '../Modal'
import {
  Container,
  StyledTitle,
  Content,
  StyledButton,
} from './styled'

const Permit2IntroModal = () => {
  const { t } = useTranslation()
  const toggle = useModalToggle(ApplicationModal.PERMIT2_INTRO)
  const isOpen = useModalOpened(ApplicationModal.PERMIT2_INTRO)

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={toggle}
      animate={false}
      contentClassName="permit2-intro"
    >
      <Container>
        <StyledTitle>{t('permit2IntroModal.title')}</StyledTitle>
        <Content>
          <div>
            <p>{t('permit2IntroModal.subtitle_1')}</p>
            <ul>
              <li>
                <span className='feature-number'>1.</span>
                <span>
                  <span className='tip'>
                    {t('permit2IntroModal.feature_1_key')}
                  </span>
                  {t('permit2IntroModal.feature_1')}
                </span>
              </li>
              <li>
                <span className='feature-number'>2.</span>
                <span>
                  <span className='tip'>
                    {t('permit2IntroModal.feature_2_key')}
                  </span>
                  {t('permit2IntroModal.feature_2')}
                </span>
              </li>
              <li>
                <span className='feature-number'>3.</span>
                <span>
                  <span className='tip'>
                    {t('permit2IntroModal.feature_3_key')}
                  </span>
                  {t('permit2IntroModal.feature_3')}
                </span>
              </li>
            </ul>
          </div>
        </Content>
        <StyledButton onClick={toggle}>{t('ok')}</StyledButton>
      </Container>
    </Modal>
  )
}

export default Permit2IntroModal
